// App.jsx
import React, { useState, useEffect } from "react";
import TicketList from "./components/TicketList";
import { useNavigate, useParams } from "react-router-dom";
import { useAppServices } from "../../../../hook/services";
import { useAgencyInfo } from "../../../../context/agency";
import LocationConnectModal from "./components/LocationConnectModal";

function App() {
  const navigate = useNavigate();
  const AppService = useAppServices();
  const [agency] = useAgencyInfo();
  const { companyId } = useParams();
  const [currentPage, setCurrentPage] = useState("list");
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [stats, setStats] = useState({
    total: 0,
    open: 0,
    inProgress: 0,
    closed: 0,
  });
  const [tickets, setTickets] = useState([]);

  useEffect(() => {
    const total = tickets.length;
    const open = tickets.filter((t) => t.status === "Open").length;
    const inProgress = tickets.filter((t) => t.status === "In Progress").length;
    const closed = tickets.filter((t) => t.status === "Closed").length;

    setStats({ total, open, inProgress, closed });
  }, [tickets]);

  const getTickets = async () => {
    try {
      const { response } = await AppService.support.get_tickets({
        query: `companyId=${companyId}`,
      });
      if (response) {
        setTickets(response.data);
      } else {
        setTickets([]);
      }
    } catch (err) {
      console.error("Error fetching tickets:", err);
    }
  };

  useEffect(() => {
    getTickets();
  }, []);

  const handleViewTicket = (ticket) => {
    navigate(`./ticket_detail/${ticket._id}`);
  };

  const handleDeleteTicket = async (ticketId) => {
  //  const { response } = await AppService.support.get_tickets({
  //       query: `_id=${ticketId}`,
  //     });
  };

  const closedRate =
    stats.total > 0 ? Math.round((stats.closed / stats.total) * 100) : 0;

  return (
    <>
      {agency?.supportAuth ? (
        <div className="st-page">
          {/* Header */}
          <header className="st-header">
            <div className="container-fluid st-header-inner d-flex align-items-center justify-content-between flex-wrap gap-3 px-4">
              <div className="d-flex align-items-center gap-3">
                <span className="st-header-icon d-inline-flex align-items-center justify-content-center">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 10v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-6" />
                    <path d="M22 10a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2" />
                    <path d="M2 14h4" />
                    <path d="M18 14h4" />
                  </svg>
                </span>
                <div>
                  <h3 className="st-title mb-1" style={{ fontSize: "1.375rem", fontWeight: 700, letterSpacing: "-0.015em", lineHeight: 1.15, color: "#0f172a" }}>
                    Support tickets
                  </h3>
                  <p className="st-subtitle mb-0">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-1" style={{ verticalAlign: "-2px" }}>
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="16" x2="12" y2="12" />
                      <line x1="12" y1="8" x2="12.01" y2="8" />
                    </svg>
                    Manage and respond to customer support tickets
                  </p>
                </div>
              </div>
              <button
                type="button"
                className="st-btn st-btn--ghost"
                onClick={() => navigate("./configuration")}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-1">
                  <circle cx="12" cy="12" r="3" />
                  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
                </svg>
                Configuration
              </button>
            </div>
          </header>

          <main className="container-fluid py-4 px-4">
            {currentPage === "list" && (
              <div className="row mb-4 g-3">
                <div className="col-xl-3 col-md-6">
                  <div className="st-stat">
                    <div className="d-flex justify-content-between align-items-start">
                      <div className="flex-grow-1" style={{ minWidth: 0 }}>
                        <div className="st-stat-label">Total tickets</div>
                        <div className="st-stat-value">{stats.total}</div>
                        <div className="st-stat-trend st-stat-trend--positive">
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" className="me-1">
                            <line x1="12" y1="19" x2="12" y2="5" />
                            <polyline points="5 12 12 5 19 12" />
                          </svg>
                          12% from last month
                        </div>
                      </div>
                      <span className="st-stat-icon st-stat-icon--neutral">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M22 10v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-6" />
                          <path d="M22 10a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-md-6">
                  <div className="st-stat">
                    <div className="d-flex justify-content-between align-items-start">
                      <div className="flex-grow-1" style={{ minWidth: 0 }}>
                        <div className="st-stat-label">Open</div>
                        <div className="st-stat-value" style={{ color: "#2563eb" }}>{stats.open}</div>
                        <div className="st-stat-trend" style={{ color: "#2563eb" }}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-1">
                            <circle cx="12" cy="12" r="10" />
                            <polyline points="12 6 12 12 16 14" />
                          </svg>
                          {stats.open > 0 ? "Needs attention" : "All clear"}
                        </div>
                      </div>
                      <span className="st-stat-icon st-stat-icon--blue">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="12" cy="12" r="10" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-md-6">
                  <div className="st-stat">
                    <div className="d-flex justify-content-between align-items-start">
                      <div className="flex-grow-1" style={{ minWidth: 0 }}>
                        <div className="st-stat-label">In progress</div>
                        <div className="st-stat-value" style={{ color: "#d97706" }}>{stats.inProgress}</div>
                        <div className="st-stat-trend" style={{ color: "#d97706" }}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-1">
                            <polyline points="1 4 1 10 7 10" />
                            <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
                          </svg>
                          Active resolution
                        </div>
                      </div>
                      <span className="st-stat-icon st-stat-icon--amber">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="1 4 1 10 7 10" />
                          <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-md-6">
                  <div className="st-stat">
                    <div className="d-flex justify-content-between align-items-start">
                      <div className="flex-grow-1" style={{ minWidth: 0 }}>
                        <div className="st-stat-label">Closed</div>
                        <div className="st-stat-value" style={{ color: "#16a34a" }}>{stats.closed}</div>
                        <div className="st-stat-trend" style={{ color: "#16a34a" }}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-1">
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                          {closedRate}% resolution rate
                        </div>
                      </div>
                      <span className="st-stat-icon st-stat-icon--green">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                          <polyline points="22 4 12 14.01 9 11.01" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="row">
              <div className="col-12">
                <TicketList
                  tickets={tickets}
                  onViewTicket={handleViewTicket}
                  onEditTicket={(ticket) => {
                    setSelectedTicket(ticket);
                    setCurrentPage("detail");
                  }}
                  onDeleteTicket={handleDeleteTicket}
                />
              </div>
            </div>
          </main>
        </div>
      ) : (
        <div className="module-connect-page">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-11">
                <div className="hero-card">
                  <div className="hero-banner">
                    <div className="hero-pill">
                      <i className="bi bi-shield-lock"></i>
                      Connection Required
                    </div>
                    <div className="hero-icon mt-3">
                      <i className="bi bi-geo-alt-fill"></i>
                    </div>
                    <h1 className="hero-title">Connect Your Support Location</h1>
                    <p className="hero-desc">
                      Authorize the GoHighLevel sub-account location where you want to receive and manage customer support tickets. Once connected, all incoming conversations will route here.
                    </p>
                  </div>

                  <div className="p-4 p-md-5">
                    <div
                      className="d-flex align-items-center gap-3 p-3 rounded-3 mb-4"
                      style={{
                        background: "#eef2ff",
                        border: "1px solid #c7d2fe",
                        color: "#3730a3",
                      }}
                    >
                      <i
                        className="bi bi-unlock-fill"
                        style={{ fontSize: 20, flexShrink: 0 }}
                      ></i>
                      <div className="small">
                        <strong>Connect your support location</strong> to unlock the ticketing dashboard. The setup takes less than a minute.
                      </div>
                    </div>

                    <div className="section-label">
                      <i className="bi bi-list-check"></i>
                      What you'll unlock
                    </div>

                    <div className="row g-3 mb-4">
                      <div className="col-12 col-md-6 col-xl-4">
                        <div className="step-card">
                          <div className="step-number">
                            <i className="bi bi-ticket-detailed"></i>
                          </div>
                          <h6 className="fw-bold mb-2">Ticket Management</h6>
                          <p className="text-muted small mb-0">
                            Organize, prioritize, and track customer support requests in one focused inbox.
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-4">
                        <div className="step-card">
                          <div className="step-number">
                            <i className="bi bi-chat-dots-fill"></i>
                          </div>
                          <h6 className="fw-bold mb-2">Customer Communication</h6>
                          <p className="text-muted small mb-0">
                            Reply, follow up, and resolve issues through threaded conversations linked to GHL contacts.
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-md-12 col-xl-4">
                        <div className="step-card">
                          <div className="step-number">
                            <i className="bi bi-graph-up-arrow"></i>
                          </div>
                          <h6 className="fw-bold mb-2">Analytics & Reports</h6>
                          <p className="text-muted small mb-0">
                            Track resolution times and team performance with built-in insights.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div
                      className="d-flex align-items-start gap-3 p-3 rounded-3 mb-4"
                      style={{
                        background: "#fef3c7",
                        border: "1px solid #fcd34d",
                        color: "#78350f",
                      }}
                    >
                      <i
                        className="bi bi-exclamation-triangle-fill mt-1"
                        style={{ fontSize: 18 }}
                      ></i>
                      <div className="small">
                        <strong>Critical:</strong> The support system will be permanently linked to the location you authorize. All tickets get associated with it, so connect the location where your team will actually handle them.
                      </div>
                    </div>

                    <div className="text-center pt-2">
                      <LocationConnectModal />
                      <div className="text-muted small mt-3">
                        Opens GoHighLevel in a new tab. Return here once authorization completes.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .st-page {
          font-family: 'Inter', sans-serif;
          background: #fafafa;
          min-height: 100vh;
        }

        /* Header */
        .st-header {
          background: #fff;
          border-bottom: 1px solid #ececec;
          padding: 18px 0;
        }
        .st-header-icon {
          width: 44px;
          height: 44px;
          border-radius: 12px;
          background: linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%);
          color: #4f46e5;
          flex-shrink: 0;
          border: 1px solid #e0e7ff;
          box-shadow: 0 1px 2px rgba(79, 70, 229, 0.06);
        }
        .st-title {
          font-size: 1.375rem;
          font-weight: 700;
          color: #0f172a;
          letter-spacing: -0.015em;
          line-height: 1.15;
        }
        .st-subtitle {
          font-size: 0.8125rem;
          color: #6b7280;
          line-height: 1.5;
        }

        /* Stat cards */
        .st-stat {
          background: #fff;
          border: 1px solid #ececec;
          border-radius: 12px;
          padding: 18px 20px;
          transition: border-color 0.15s ease, box-shadow 0.2s ease;
          height: 100%;
        }
        .st-stat:hover {
          border-color: #dcdcdc;
          box-shadow: 0 1px 2px rgba(17, 24, 39, 0.04), 0 4px 12px rgba(17, 24, 39, 0.04);
        }
        .st-stat-label {
          font-size: 0.6875rem;
          font-weight: 600;
          color: #64748b;
          letter-spacing: 0.06em;
          text-transform: uppercase;
        }
        .st-stat-value {
          font-size: 2rem;
          font-weight: 700;
          color: #0f172a;
          letter-spacing: -0.02em;
          margin: 6px 0 8px;
          line-height: 1.1;
        }
        .st-stat-trend {
          display: inline-flex;
          align-items: center;
          font-size: 0.75rem;
          font-weight: 500;
          color: #6b7280;
        }
        .st-stat-trend--positive { color: #16a34a; }
        .st-stat-icon {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .st-stat-icon--neutral { background: #f3f4f6; color: #4b5563; }
        .st-stat-icon--blue { background: #eff6ff; color: #2563eb; }
        .st-stat-icon--amber { background: #fef3c7; color: #d97706; }
        .st-stat-icon--green { background: #f0fdf4; color: #16a34a; }

        /* Buttons */
        .st-btn {
          display: inline-flex;
          align-items: center;
          font-size: 0.8125rem;
          font-weight: 600;
          letter-spacing: 0.005em;
          padding: 8px 14px;
          border-radius: 8px;
          border: 1px solid transparent;
          line-height: 1;
          cursor: pointer;
          font-family: inherit;
          text-decoration: none;
          transition: transform 0.15s ease, box-shadow 0.2s ease, background 0.2s ease, border-color 0.15s ease, color 0.15s ease;
        }
        .st-btn:focus-visible {
          outline: none;
          box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.2);
        }
        .st-btn--ghost {
          background: #fff;
          border-color: #e5e7eb;
          color: #1f2937;
          box-shadow: 0 1px 2px rgba(17, 24, 39, 0.04);
        }
        .st-btn--ghost:hover {
          background: #fafafa;
          border-color: #d1d5db;
          color: #1f2937;
          transform: translateY(-1px);
          box-shadow: 0 2px 4px rgba(17, 24, 39, 0.05), 0 6px 14px rgba(17, 24, 39, 0.06);
        }
        .st-btn--ghost:active { transform: translateY(0); }

        /* Module-connect style (mirrors LocationCreator / CustomValueForm / LocationIntiater) */
        .module-connect-page {
          min-height: 100vh;
          background: linear-gradient(160deg, #f8fafc 0%, #eef2ff 50%, #f8fafc 100%);
          padding: 48px 16px;
        }
        .module-connect-page .hero-card {
          border-radius: 20px;
          background: #ffffff;
          box-shadow: 0 8px 30px rgba(15, 23, 42, 0.06), 0 2px 8px rgba(15, 23, 42, 0.03);
          overflow: hidden;
        }
        .module-connect-page .hero-banner {
          background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 60%, #ec4899 100%);
          padding: 28px 28px 36px;
          color: #ffffff;
          position: relative;
          overflow: hidden;
        }
        .module-connect-page .hero-banner h1.hero-title {
          font-size: 1.5rem !important;
          line-height: 1.25 !important;
          font-weight: 700 !important;
          margin: 0 0 8px !important;
          letter-spacing: -0.01em;
          color: #ffffff !important;
        }
        .module-connect-page .hero-banner p.hero-desc {
          font-size: 0.9rem !important;
          line-height: 1.55 !important;
          margin: 0 !important;
          color: rgba(255, 255, 255, 0.88);
          max-width: 720px;
        }
        @media (min-width: 768px) {
          .module-connect-page .hero-banner h1.hero-title { font-size: 1.75rem !important; }
          .module-connect-page .hero-banner p.hero-desc { font-size: 0.95rem !important; }
        }
        .module-connect-page .hero-banner::before {
          content: "";
          position: absolute;
          top: -120px;
          right: -120px;
          width: 320px;
          height: 320px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(255,255,255,0.18), transparent 70%);
          pointer-events: none;
        }
        .module-connect-page .hero-banner::after {
          content: "";
          position: absolute;
          bottom: -140px;
          left: -100px;
          width: 280px;
          height: 280px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(255,255,255,0.12), transparent 70%);
          pointer-events: none;
        }
        .module-connect-page .hero-icon {
          width: 56px;
          height: 56px;
          border-radius: 14px;
          background: rgba(255, 255, 255, 0.18);
          backdrop-filter: blur(8px);
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 14px;
          border: 1px solid rgba(255, 255, 255, 0.25);
        }
        .module-connect-page .hero-icon i { font-size: 1.6rem; }
        .module-connect-page .hero-pill {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: rgba(255, 255, 255, 0.18);
          color: #ffffff;
          font-weight: 600;
          font-size: 12px;
          letter-spacing: 0.5px;
          text-transform: uppercase;
          padding: 6px 12px;
          border-radius: 999px;
          border: 1px solid rgba(255, 255, 255, 0.22);
        }
        .module-connect-page .step-card {
          border-radius: 16px;
          padding: 22px;
          background: #ffffff;
          border: 1px solid #eef0f4;
          height: 100%;
          transition: border-color 0.2s ease, box-shadow 0.2s ease;
        }
        .module-connect-page .step-card:hover {
          border-color: #c7d2fe;
          box-shadow: 0 6px 20px rgba(99, 102, 241, 0.08);
        }
        .module-connect-page .step-card .step-number {
          width: 44px;
          height: 44px;
          border-radius: 12px;
          background: linear-gradient(135deg, #6366f1, #8b5cf6);
          color: #ffffff;
          font-weight: 700;
          font-size: 18px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 6px 16px rgba(99, 102, 241, 0.3);
          margin-bottom: 14px;
        }
        .module-connect-page .step-card h6 {
          font-size: 1rem;
          line-height: 1.35;
          word-break: break-word;
        }
        .module-connect-page .section-label {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.8px;
          text-transform: uppercase;
          color: #6366f1;
          margin-bottom: 12px;
        }
        /* Tone the LocationConnectModal trigger to match the gradient CTA used elsewhere */
        .module-connect-page .btn-secondary {
          background: linear-gradient(135deg, #6366f1, #8b5cf6) !important;
          border: none !important;
          color: #ffffff !important;
          padding: 14px 36px !important;
          border-radius: 12px !important;
          font-weight: 600 !important;
          font-size: 15px !important;
          box-shadow: 0 10px 24px rgba(99, 102, 241, 0.35) !important;
          transition: transform 0.2s ease, box-shadow 0.2s ease !important;
        }
        .module-connect-page .btn-secondary:hover {
          transform: translateY(-2px);
          box-shadow: 0 14px 28px rgba(99, 102, 241, 0.4) !important;
          color: #ffffff !important;
        }
        .st-connect-subtitle {
          font-size: 0.9375rem;
          color: #6b7280;
          line-height: 1.55;
          max-width: 560px;
          margin-left: auto;
          margin-right: auto;
        }

        /* Feature */
        .st-feature {
          padding: 22px 20px;
          background: #fff;
          border: 1px solid #ececec;
          border-radius: 14px;
          transition: border-color 0.15s ease, box-shadow 0.2s ease, transform 0.15s ease;
        }
        .st-feature:hover {
          border-color: #c7d2fe;
          box-shadow: 0 1px 2px rgba(17, 24, 39, 0.04), 0 6px 16px rgba(79, 70, 229, 0.08);
        }
        .st-feature-icon {
          width: 44px;
          height: 44px;
          border-radius: 12px;
        }
        .st-feature-icon--indigo { background: #eef2ff; color: #4f46e5; border: 1px solid #e0e7ff; }
        .st-feature-icon--green { background: #f0fdf4; color: #16a34a; border: 1px solid #bbf7d0; }
        .st-feature-icon--amber { background: #fef3c7; color: #d97706; border: 1px solid #fde68a; }
        .st-feature-title {
          font-size: 1rem;
          font-weight: 600;
          color: #0f172a;
          letter-spacing: -0.008em;
          margin-bottom: 6px;
        }
        .st-feature-text {
          font-size: 0.8125rem;
          color: #6b7280;
          line-height: 1.5;
        }

        /* Callout */
        .st-callout {
          padding: 14px 16px;
          background: #fffbeb;
          border: 1px solid #fde68a;
          border-radius: 12px;
        }
        .st-callout-pill {
          width: 26px;
          height: 26px;
          border-radius: 50%;
          background: #fef3c7;
          color: #b45309;
          border: 1px solid #fde68a;
          margin-top: 1px;
        }
        .st-callout-title {
          font-size: 0.8125rem;
          font-weight: 600;
          color: #92400e;
          margin-bottom: 2px;
        }
        .st-callout-text {
          font-size: 0.8125rem;
          color: #78350f;
          line-height: 1.55;
        }
        .st-callout-text strong { color: #78350f; font-weight: 600; }

        /* Responsive */
        @media (max-width: 720px) {
          .st-connect-hero { padding: 36px 24px 32px; }
          .st-connect-body { padding: 24px 24px 32px; }
          .st-connect-title { font-size: 1.5rem; }
          .st-connect-hero-icon { width: 64px; height: 64px; border-radius: 18px; }
        }
      `}</style>
    </>
  );
}

export default App;
